import React from 'react';
import UnifiedHeadToHead from './UnifiedHeadToHead';

/**
 * Main Head-to-Head Records component
 * Now uses the unified interface that consolidates Individual, Team, and "Played With"
 */
const HeadToHeadRecords = ({ currentPlayerId, selectedClub, selectedSeason, initialOpponentId = null }) => {
  return (
    <UnifiedHeadToHead 
      currentPlayerId={currentPlayerId}
      selectedClub={selectedClub}
      selectedSeason={selectedSeason}
      initialOpponentId={initialOpponentId}
    />
  );
};

export default HeadToHeadRecords;
